import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";

export const getAvailableLocales = (): BaseMenuItem[] => [
  {
    name: "en",
    text: $t("English"),
  },
  {
    name: "es",
    text: $t("Spanish"),
  },
  {
    name: "pt",
    text: $t("Portuguese"),
  },
  {
    name: "it",
    text: $t("Italian"),
  },
];
